import React from "react";
import svg62 from "../../assets/svg/svg62.svg";
import { useSelector } from "react-redux";

function IwuaCounCard() {
  const url = "api/v2/dashboard/getAllDashboardData";
  const data = useSelector((state) => state.fetch.data[url] || []);

  const waterSources =
    data?.iwuaData?.length > 0
      ? Object.entries(data?.iwuaData?.[0])?.map(([key, value]) => ({
          title: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase()),
          count: value,
        }))
      : [];

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white w-full  h-full">
      <div className="flex items-center gap-x-[.65rem]">
        <span className="">IWUAs</span>
        <img src={svg62} alt="svg62" />
      </div>
      <div className="flex flex-shrink flex-wrap items-start gap-[1rem] w-full mt-[2rem]">
        {waterSources &&
          waterSources?.map((item, index) => (
            <>
              <div key={index} className="flex-1 w-full">
                <div className="text-[#050505] text-[.875rem] font-[400] font-roboto">
                  {item?.title}
                </div>
                <div className="mt-[2rem] flex justify-between items-center">
                  <span className="text-[#050505] font-interSans text-[1.5rem] font-[500]">
                    {item?.count}
                  </span>
                </div>
              </div>
              {index !== waterSources?.length - 1 && (
                <span className="lg:h-[5rem] h-0 lg:w-0 w-full lg:border-l border-b border-[#D6E1F5] lg:mx-[2.5rem] "></span>
              )}
            </>
          ))}
      </div>
    </div>
  );
}

export default IwuaCounCard;
